import React, { useContext } from "react";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap/esm/Button";
import { AppContext } from "../provider/AppContext";

const ModalComponent = ({
  show,
  title,
  children,
  setShowPlanner,
  onExit = () => {},
}) => {
  const { appData, setAppData } = useContext(AppContext);
  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          setShowPlanner(false);
          setAppData({ ...appData, showPlanner: false });
        }}
        onExit={onExit}
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowPlanner(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default ModalComponent;
